// extracted by mini-css-extract-plugin
export var article = "splitList-module--article--l6ptm";
export var body = "splitList-module--body--Hrmqi";
export var buttonsWrapper = "splitList-module--buttonsWrapper--JMWnL";
export var img = "splitList-module--img--MOMDK";
export var sbShowMain = "splitList-module--sb-show-main--YQcWD";
export var splitList = "splitList-module--splitList--1DMPf";
export var title = "splitList-module--title--s5kiR";